import { render, staticRenderFns } from "./terminals.vue?vue&type=template&id=34cc884d&scoped=true"
import script from "./terminals.vue?vue&type=script&lang=js"
export * from "./terminals.vue?vue&type=script&lang=js"
import style0 from "./terminals.vue?vue&type=style&index=0&id=34cc884d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cc884d",
  null
  
)

export default component.exports